import { MARKET_TYPE, SEC_TYPE } from 'const/stock'
import stockIsEtf from 'utils/stockIsEtf'

export default function choiceFilter(stock, value) {
  const isHK = stock.market === MARKET_TYPE.HK
  const isUS = stock.market === MARKET_TYPE.US
  const isUK = stock.market === MARKET_TYPE.UK
  const isAStock = [MARKET_TYPE.SH, MARKET_TYPE.SZ].indexOf(stock.market) > -1
  const isWarrant = [SEC_TYPE.WAR, SEC_TYPE.IOPT].indexOf(stock.secType) > -1
  const isETF = stockIsEtf(stock)
  const isFUT =
    stock.futContent && stock.futContent.securityType === SEC_TYPE.FUT
  const isOPT = stock.secType === SEC_TYPE.OPT
  if (isWarrant || (isAStock && isETF) || isHK) {
    return 3
  } else if (isOPT || isAStock) {
    return 2
  } else if (isUK || isUS) {
    if (typeof value !== 'undefined') {
      return Math.abs(value) >= 1 || value === 0 ? 2 : 4
    }
    const price = stock.latestPrice || stock.preClose
    return Math.abs(price) >= 1 || price === 0 ? 2 : 4
  } else if (isFUT) {
    return stock.futContent.productPriceConfig.maxScale || 0
  }
  return 0
}
